import { apiSlice } from "@/shared/api/api-slice"

import type { GetSafeListResponse, GetSafeListTransformedResponse } from "./types"

export const getSafeListApi = apiSlice
  .enhanceEndpoints({
    addTagTypes: ["SafeList"]
  })
  .injectEndpoints({
    endpoints: builder => ({
      getSafeList: builder.query<GetSafeListTransformedResponse, number>({
        query: chatId => `/api/v1/security/safe-list/chat/${chatId}`,
        transformResponse: (response: GetSafeListResponse) => response.result,
        providesTags: (_result, _error, chatId) => [{ type: "SafeList" as const, id: chatId }]
      })
    })
  })

export const { useGetSafeListQuery } = getSafeListApi
